import { useState, useEffect } from 'react'
import { Button } from '#app/components/ui/button.tsx'

export function CookieConsent() {
	const [showBanner, setShowBanner] = useState(false)

	useEffect(() => {
		const consent = document.cookie
			.split('; ')
			.find((row) => row.startsWith('cookie_consent='))
		if (!consent) {
			setShowBanner(true)
		}
	}, [])

	function handleAccept() {
		document.cookie =
			'cookie_consent=accepted; path=/; max-age=31536000; SameSite=Lax'
		setShowBanner(false)
	}

	function handleDecline() {
		document.cookie =
			'cookie_consent=declined; path=/; max-age=31536000; SameSite=Lax'
		setShowBanner(false)
	}

	if (!showBanner) return null

	return (
		<div className="fixed inset-x-0 bottom-0 z-50 p-4">
			<div className="surface-2 mx-auto flex max-w-2xl flex-col gap-4 rounded-xl border p-4 sm:flex-row sm:items-center sm:justify-between">
				<p className="text-sm">
					Folosim cookie-uri esențiale pentru funcționarea platformei. Consultă{' '}
					<a href="/privacy" className="underline">
						Politica de Confidențialitate
					</a>
					.
				</p>
				<div className="flex gap-2">
					<Button variant="ghost" size="sm" onClick={handleDecline}>
						Refuz
					</Button>
					<Button size="sm" onClick={handleAccept}>
						Accept
					</Button>
				</div>
			</div>
		</div>
	)
}
